module.exports = __webpack_public_path__ + "img/hazrat-masoomeh-logo.ca584349.svg";